/**
 * Created by Mark on 17/03/2017.
 */

import React from "react";
import { FormattedMessage } from 'react-intl';
import DatePicker from 'react-bootstrap-date-picker';
import DateHelper from '../../classes/date.js'
import DateInput from 'react-datepicker';
import moment from 'moment';
import 'react-datepicker/dist/react-datepicker.css';
import InternationalizationStore from '../../store/internationalization-store.js';
class SingleInput extends React.Component {

    constructor(props) {        
        super();
        moment.locale(InternationalizationStore.determineLocaleFromBrowser());
        var d = new Date();
        this.props = props;

        this.state = {
            value: moment(this.convertValueToISOString(props.value).replace(/T(.*)$/g)),
            toggled: false
        }
    }

    convertValueToISOString(value) {
        return Number(value) > 0 ? (new Date(Number(value) * 1000)).toISOString() : value
    }

    toggleFocus() {
        if (!(!this.state.value || 0 === this.state.value.length)) this.setState({ toggled: true });
        else this.setState({ toggled: !this.state.toggled });
    }

    componentWillReceiveProps(props){
        this.props = props;

        this.setState({value : moment(this.convertValueToISOString(props.value))});
    }

    handleChange(value) {

        if(value == null) return this.setState({});
        this.setState({value: value ,   startDate: value});
        if(this.props.onSelect) this.props.onSelect(value.format('YYYY-MM-DD'));
    }


    render() {

        const month = (new DateHelper()).getAllMonths();
        const label = !this.props.noLabel ?  <label className="fg-label control-label"><FormattedMessage id={this.props.labelTranslationUID} defaultMessage={this.props.labelName}/></label> : null;

        return <div className={"form-group fg-line " + (this.state.toggled ? 'fg-toggled' : '') }>
                        {label}
                        <br/>
                        <DateInput dateFormat="DD/MM/YYYY" selected={this.state.value} onBlur={this.toggleFocus.bind(this)} onFocus={this.toggleFocus.bind(this)} className="form-control input-mask" onChange={this.handleChange.bind(this)}/>
                </div>;
    }
}

export default SingleInput;


// WEBPACK FOOTER //
// ./src/components/inputs/date.input.js